import { useEffect } from 'react';

export default function JsonLd({ data }) {
  useEffect(() => {
    if (!data) return;
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-pixelutility-jsonld', 'true');
    script.text = JSON.stringify(data);
    document.head.appendChild(script);
    return () => {
      const el = document.querySelector('script[data-pixelutility-jsonld="true"]');
      if (el?.parentNode) el.parentNode.removeChild(el);
    };
  }, [data]);

  return null;
}
